import { DEPOSIT_PREV_PATH_LS_KEY } from './config';

/** Сохраняет путь для возврата на него после флоу платежки.
 * Вызовите функцию savePath в депозите, для всех методов, которые
 * делают редирект на платежку. Вызвать ровно перед редиректом.
 */
export const useSavePathFromDeposit = () => {
  const searchParams = location.search;

  const savePath = () =>
    sessionStorage.setItem(DEPOSIT_PREV_PATH_LS_KEY, `${location.pathname}${searchParams}`);
  return { savePath };
};
